import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SocialsContact } from '@/components';

import { ModalInfo, ModalInfoProps } from '../ModalInfo';

import styles from './SocialsContactModal.module.sass';

interface SocialsContactModalProps extends ModalInfoProps {}

const SocialsContactModal: FC<SocialsContactModalProps> = (props) => {
  const { title, isOpen, onClose } = props;
  const { t } = useTranslation();

  return (
    <ModalInfo
      isOpen={isOpen}
      title={title?.length ? title : t('translation.support_lnk')}
      className={styles.modal}
      onClose={onClose}
    >
      <SocialsContact className={styles.centered} />
    </ModalInfo>
  );
};

export default SocialsContactModal;
